(() => {
  const selector = '[data-collection-hero-mobile-video]';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initializedVideos = new WeakSet();

  const loadVideoSources = (video) => {
    if (video.dataset.sourcesLoaded === 'true') return;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.dataset.sourcesLoaded = 'true';
    video.load();
  };

  const safelyPlay = (video) => {
    if (!mobileQuery.matches || reducedMotionQuery.matches || document.hidden) return;

    loadVideoSources(video);
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        // The poster remains visible when a browser or device blocks autoplay.
      });
    }
  };

  const initializeVideo = (video) => {
    if (initializedVideos.has(video)) return;
    initializedVideos.add(video);

    let isVisible = false;

    const syncPlayback = () => {
      if (mobileQuery.matches && !reducedMotionQuery.matches && isVisible && !document.hidden) {
        safelyPlay(video);
      } else {
        video.pause();
      }
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target !== video) return;
            isVisible = entry.isIntersecting && entry.intersectionRatio > 0.05;
            syncPlayback();
          });
        },
        { threshold: [0, 0.05, 0.25] }
      );

      observer.observe(video);
    } else {
      isVisible = true;
      syncPlayback();
    }

    const handlePreferenceChange = () => syncPlayback();

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handlePreferenceChange);
      reducedMotionQuery.addEventListener('change', handlePreferenceChange);
    } else {
      mobileQuery.addListener(handlePreferenceChange);
      reducedMotionQuery.addListener(handlePreferenceChange);
    }

    document.addEventListener('visibilitychange', syncPlayback);
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll(selector).forEach(initializeVideo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
